import { useTextColor } from '@/resources/hooks/useTextColor';
import { useWebContext } from '@/resources/hooks/useWebContext';

import { useNavbarContext } from '../../hooks/useNavbarContext';
import ActiveCategoriesList from './ActiveCategoriesList';
import CategoryLink from './CategoryLink';

interface Props {
  showActivedList?: boolean;
}

function HighlightedCategoriesList({ showActivedList = false }: Props) {
  const { highlightedCategories: allCategories } = useNavbarContext();
  const { configs } = useWebContext();
  const textColor = useTextColor(configs.navbar_footer_color);

  const highlightedCategories = allCategories?.filter((category) => category.highlighted_desktop);

  return (
    <div className="d-flex align-items-center justify-content-between">
      {showActivedList && <ActiveCategoriesList iconSize="25" label />}

      <ul className="d-flex list-inline mb-0 navbar-categories-list w-100 pb-1 align-items-center">
        {highlightedCategories?.map((category) => (
          <CategoryLink
            color={textColor}
            category={category}
            className="navbar-category-link list-inline-item"
            key={`highlighted-categories-navbar-${category.id}-${category.type}`}
            type={category.type}
          />
        ))}
      </ul>
    </div>
  );
}

export default HighlightedCategoriesList;
